/* import __COLOCATED_TEMPLATE__ from './multi-payment-row.hbs'; */
import { getAmount, getDate } from '@banking/ui/models/checking/balances/unified-activity';
import { activityIconStyles } from '@banking/ui/utils/activity';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  intl: service(),
  localeTime: service(),
  isOriginalPayment: null,
  payment: null,
  reachedMaxSelectedPayments: null,
  selected: null,
  merchantImageUrl: readOnly('payment.merchantImage.merchantImageUrl'),
  activityIconStyles: computed('payment', function () {
    return activityIconStyles(this.payment);
  }),
  amount: computed('payment.{amount,activityState}', function () {
    return getAmount(this.payment.amount, this.payment.activityState);
  }),
  date: computed('payment.{availableAt,latestEventAt,lineItems.firstObject.timestamp.value}', function () {
    if (this.payment.lineItems) {
      return this.payment.lineItems.firstObject.timestamp.value;
    } else if (this.payment.availableAt) {
      return this.intl.formatDate(this.payment.availableAt, {
        format: 'fullDateLong'
      });
    } else {
      return getDate(this.payment.latestEventAt, this.localeTime);
    }
  }),
  isCheckboxDisabled: computed('reachedMaxSelectedPayments', 'selected', function () {
    return this.reachedMaxSelectedPayments && !this.selected;
  }),
  // eslint-disable-next-line ember/no-actions-hash
  actions: {
    onMarketRowToggled() {
      this.isOriginalPayment ? this.paymentSelected() : this.paymentSelected(this.payment);
      this.setProperties({
        selected: !this.selected
      });
    }
  }
});